export const consultationQueryKeys = {
  consultants: (customer_id: number, date: string) => ['consultations', 'consultants', customer_id, date] as const,
  myConsultations: (customer_id: number) => ['consultations', 'my', customer_id] as const,
};
